<template>
  <div class="UpdatePackage-down" align="" style="width:80%">
    <div>
      <div class="title" :inline="true">
        <el-form >
          <el-form-item   :label="`${$t('DataUppackage.title')}`"  >          
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
            <a  href="/">{{$t('navBar.goback')}}</a> 
        </el-breadcrumb-item>

      </el-breadcrumb>
      <div class="container" v-if="list">
        <el-table
          :data="list"
          style="width: 100%;">
          <!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            v-if="false">
          </el-table-column>
          <el-table-column
            fixed
            prop="obs_id"
            label="观测号">        
          </el-table-column>
          <el-table-column
            prop="level"
            label="数据级别">
            <template slot-scope="{row}">
              <span :title="$t(`DataRelease.level.${row.level}`)">{{$t(`DataRelease.level.${row.level}`)}}</span>
            </template>>
          </el-table-column>
          <el-table-column
            prop="file_ver"
            label="数据版本">
          </el-table-column>
          <el-table-column
            prop="archive_time"
            label="数据归档日期">
          </el-table-column> 

          <el-table-column
            :label="$t('proposal.operate')"
            width="150"
            v-if="true">
            <template slot-scope="scope"  >
              <div>               
                <el-dropdown @command="UpkDownload">
                  <el-button type="primary" size="small" class="op-btn">
                    {{$t('proposal.download')}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{type: 'download', row: scope.row}">
                      {{$t('proposal.webdownload')}}
                    </el-dropdown-item>
                    <el-dropdown-item :command="{type: 'copy', row: scope.row}">
                      {{$t('proposal.copy_downlink')}}
                    </el-dropdown-item>
                    <el-dropdown-item :command="{type: 'wget', row: scope.row}">
                      {{$t('proposal.get_wget')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>             
            </template>
          </el-table-column>

        </el-table>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes.sync="pageSizes"
          :page-size.sync="pageSize"
          :total="total"
          @size-change="getData"
          @current-change="getData">
        </el-pagination>
        <copyTextDialog
          :dialog-visible="copyTextDialogVisible"
          :dialog-data="copyTextDialogData"
          @close="closeCopyTextDialog">
        </copyTextDialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import copyTextDialog from './copyTextDialog';

export default {
  components: {
    copyTextDialog,
  },
  name: 'UpdatePackageDown',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: null,
      ProposalInfoForm:{
      },
      list: [],
      currentPage: 1,
      pageSizes:[10,20, 50, 100, 200,300],
      pageSize: 10,
      total: 0,
      copyTextDialogVisible: false,
      copyTextDialogData: '',
      orderDirection: null,
      orderProp: '',
    };
  },
  created() {
    this.getData();
  },
 
  methods: {
    getData() {
      const params = {
        obs_id : this.id,
      }
      axios.post('/iapi/DataUpgrade', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
          // console.log('data',this.data);
  
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    UpkDownload(data){
      let urls = '';
      if(!(data.type === 'wget')) {
        urls =  window.location.protocol+'//'+window.location.host+'/iapi/upkdownload/'+data.row.downcode;
      }else if(data.type === 'wget'){
        urls = ' wget -c -t 0 -O '+data.row.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/upkdownload/'+data.row.downcode;
      }
 
      if (data.type === 'download') {
        // console.log('下载地址',item);
        // window.open(item);
        let a = document.createElement('a'); // 创建a标签
        let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
        e.initEvent('click', false, false); // 初始化事件对象
        a.href = urls; // 设置下载地址
        a.download = ''; // 设置下载文件名
        a.dispatchEvent(e);
      }
      if (data.type === 'copy') {
        this.copyTextDialogData = urls;
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'wget') {
        this.copyTextDialogData = urls;
        this.copyTextDialogVisible = true;
      }
    },
    closeCopyTextDialog() {
      this.copyTextDialogVisible = false;
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>

.UpdatePackage-down{
  padding: 24px 56px;
  margin:0 auto;
}
.title {
  margin-right: 56px;
  font-size: 40px;
  color: #fff;
  font-weight: 50;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 5px;
    margin-bottom: 5px;
}
.admin-path {
  margin-bottom: 30px;
}
</style>
